import React from 'react';

const BrandLogo = ({ className = "w-8 h-8", iconOnly = false }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className="relative flex-shrink-0">
        {/* Shield Base */}
        <svg viewBox="0 0 24 24" fill="none" className="w-8 h-8 drop-shadow-[0_0_8px_rgba(245,158,11,0.3)]">
          <path 
            d="M12 2L4 5V11C4 16.19 7.41 21.05 12 22.5C16.59 21.05 20 16.19 20 11V5L12 2Z" 
            className="fill-slate-900 stroke-amber-500" 
            strokeWidth="1.5"
          />
          {/* Cloud/Data Symbol inside Shield */}
          <path 
            d="M15.5 13.5C15.5 14.88 14.38 16 13 16H10.5C8.57 16 7 14.43 7 12.5C7 10.68 8.4 9.18 10.17 9.02C10.74 7.82 11.97 7 13.38 7C15.31 7 16.88 8.57 16.88 10.5C16.88 10.72 16.85 10.93 16.81 11.13C17.51 11.45 18 12.17 18 13C18 14.1 17.1 15 16 15" 
            className="stroke-amber-400" 
            strokeWidth="1.2" 
            strokeLinecap="round"
          />
          <path 
            d="M10 13L11.5 14.5L14.5 11.5" 
            className="stroke-emerald-400" 
            strokeWidth="1.5" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {!iconOnly && (
        <span className="text-xl font-bold text-slate-100 tracking-tight">
          Compliance<span className="text-amber-500">Cloud</span>
        </span>
      )}
    </div>
  );
};

export default BrandLogo;